import * as React from 'react';

import Navbar from "../../Layouts/Navbar";
import {IoSearchCircleOutline} from "react-icons/io5";
import {TiLocationOutline} from "react-icons/ti";
import {BiCategoryAlt} from "react-icons/bi";
import {TbAward} from "react-icons/tb";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
// import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import {GoStarFill} from "react-icons/go";

export default function Home() {
    const navigate = useNavigate();

    const [serviceGroups, setserviceGroups] = React.useState([]);
    const [servitorCompanies, setServitorCompanies] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    // const [slides, setSlides] = React.useState([]);

    React.useEffect(() => {
        API.getServiceGroups()
            .then((response) => {
                setserviceGroups(response.data);
                setIsLoaded(true);
               /* API.getSlides()
                    .then((response) => {
                        setSlides(response.data);
                        setIsLoaded(true);
                    })
                    .catch((error) => {
                        if(error.response) {
                            toast.error(error.response.data.message);
                        }
                        else {
                            toast.error(error.message);
                        }
                    });*/
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

        const params = {
            list: 1,
            orderType: 'desc',
            count: 4
        }
        API.getServitorCompanies(params)
            .then((response) => {
                setServitorCompanies(response.data);
                // setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

    }, []);

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            {/*Search*/}
            <section className="container-fluid  py-3 rtl px-2 ">
                <div className="row search-city mx-2">
                    <div className="col-8 border-start border-secondary border-opacity-25"
                         onClick={
                             () => {
                                 navigate(`/search`);
                             }
                         }
                    >
                        <IoSearchCircleOutline className='text-secondary text-big-3' />
                        <span className='text-secondary text-small-3 pe-3'>
                            جستجو در همه خدمات
                        </span>
                    </div>
                    <div className="col-4 text-center "
                    onClick={ () => toast.info('در حال حاضر خدمات فقط در شهر مشهد ارائه می شود')}
                    >
                        <span className='text-small-2 px-2 text-secondary'>
                            مشهد
                        </span>
                        <TiLocationOutline className='text-secondary' />
                    </div>

                </div>
            </section>


            {/*Categories*/}
            <section className="container-fluid  py-2 rtl px-0  ">
                <div className="row mx-2">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2' />
                        دسته بندی ها
                    </div>
                </div>

                <div className="row mx-2">
                    {
                        serviceGroups.map (group => {
                            return (
                                <div className="col-4 text-center service-group" key={group.id}
                                     onClick={
                                         () => {
                                             navigate(`/home/companies/${group.id}`);
                                         }
                                     }
                                >
                                    <div className="group-image-container">
                                        <img src={group.image} alt={group.name}/>
                                        <div className="title mt-2">

                                            {group.name.substring(0, 22)}
                                            {
                                                group.name.length > 22 ?
                                                    <span className='text-small-4'>
                                                    ...
                                                </span>
                                                    : ''
                                            }
                                        </div>
                                    </div>

                                </div>
                            )} )}




                </div>
            </section>


            {/*Slideshow*/}
            {/*<div className="container-fluid px-0 mx-0 my-5">
                <Fade>
                    {slides.map((slide) => (
                        <div key={slide.id} >
                             <h2>{slide.name}</h2>
                            <img style={{ width: '100%' }} src={slide.image} alt={slide.name}  className='slide-image'/>
                        </div>
                    ))}
                </Fade>
            </div>*/}

            {/* Servitor */}
            <section className="container-fluid  my-3 pt-2 pb-5 rtl px-0  ">
                <div className="row mx-2">
                    <div className="col-12 home-separator-text ">
                        <TbAward className='mx-2' />
                        ارائه دهندگان خدمات منتخب
                    </div>
                </div>

                <div className="row mx-3 ">
                    {
                        servitorCompanies.map (company => {
                            return (
                                <div className="col-12 p-1" key={company.id}
                                     onClick={
                                         () => {
                                             navigate(`/company/${company.id}`);
                                         }
                                     }
                                >
                                    <div className="servitor-container row">
                                        <div className="col-2 p-2 servitor-image">
                                            <img src={company.image} alt={company.title} />
                                        </div>
                                        <div className="col-10">
                                            <div className="title py-2 pe-2">
                                                {company.title}
                                                <span className='float-start fw-bold text-small-2 badge badge-pill badge-primary bg-secondary-subtle bg-opacity-75 text-dark'>
  <GoStarFill className='text-big-1 text-warning' />
                                                     {company.score}

                                                </span>
                                            </div>
                                            <div className="description pe-2">
                                                {company.brief.substr(0,100)} ...
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )} )

                    }
                </div>
            </section>


            <Navbar />
        </React.Fragment>
    );
};
